// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-89EB5220-D338-4828-9A86-3C49EB01F2FE .pointer-cursor {\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://src/erp/inventory/rawData/productGroup/productGroupSelector/productGroupSelector.less"],"names":[],"mappings":"AAAA;EAEQ,eAAA;AAAR","sourcesContent":["#V-89EB5220-D338-4828-9A86-3C49EB01F2FE{\n    .pointer-cursor {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
